import { MesfModal } from "@dexteel/mesf-core";
import {
	Autocomplete,
	Button,
	Chip,
	Grid2,
	TextField,
	Tooltip,
} from "@mui/material";
import { useState } from "react";
import { Section } from "../models/Section";
import { SectionsOfPartSelector } from "./SectionsOfPartSelector";

type Props = {
	label: string;
	onSelectionChanged: Function;
	onSaved?: Function;
	sectionsOfPart: Section[];
	partId?: number;
	disabled?: boolean;
};

export const SectionField = ({
	label,
	onSelectionChanged,
	onSaved,
	sectionsOfPart,
	disabled = false,
}: Props) => {
	const [openModal, setOpenModal] = useState<boolean>(false);
	const [initialSections, setInitialSections] = useState<Section[]>([]);

	const handleOpenModal = () => {
		setInitialSections(sectionsOfPart);
		setOpenModal(true);
	};

	return (
		<>
			<Autocomplete
				multiple
				open={false}
				options={[]}
				value={sectionsOfPart}
				disabled={disabled}
				getOptionLabel={(option) => option.SectionName}
				onChange={(_e, _value, reason) => {
					if (reason === "clear") onSelectionChanged([]);
					if (reason === "removeOption") onSelectionChanged(_value);
					_e.stopPropagation();
				}}
				renderTags={(value, getTagProps) =>
					value.map((section, index) => {
						const { key, ...tagProps } = getTagProps({ index });
						return (
							<Tooltip key={key} title="See in sections">
								<Chip
									{...tagProps}
									label={section.SectionName}
									size="small"
									color="primary"
									variant="outlined"
									clickable
									onClick={(e) => {
										e.stopPropagation();
										window.open(
											`/configuration/sections/${section.SectionId}`,
											"_blank",
										);
									}}
								/>
							</Tooltip>
						);
					})
				}
				renderInput={(params) => (
					<TextField
						{...params}
						label={label}
						size="small"
						variant="outlined"
						onClick={handleOpenModal}
						InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
						inputProps={{
							...params.inputProps,
							readOnly: true,
							"data-test-id": "section-field-selector",
						}}
					/>
				)}
			/>
			<MesfModal
				title="CHOOSE SECTIONS"
				open={openModal}
				handleClose={() => setOpenModal(false)}
			>
				<MesfModal.Content dividers>
					<SectionsOfPartSelector
						sectionsOfPart={sectionsOfPart}
						onSelectionChanged={onSelectionChanged}
					/>
				</MesfModal.Content>
				<MesfModal.Actions style={{ padding: "20px 30px" }}>
					<Grid2 container spacing={2} justifyContent="flex-end">
						<Grid2 size={{ md: 3, xs: 12 }} style={{ margin: 0 }}>
							<Button
								fullWidth
								variant="contained"
								color="inherit"
								onClick={() => {
									onSelectionChanged(initialSections);
									setOpenModal(false);
								}}
							>
								Cancel
							</Button>
						</Grid2>
						<Grid2 size={{ md: 3, xs: 12 }} style={{ margin: 0 }}>
							<Button
								fullWidth
								variant="contained"
								color="primary"
								onClick={() => {
									onSaved ? onSaved() : null;
									setOpenModal(false);
								}}
								data-test-id="save-sections-button"
							>
								Save
							</Button>
						</Grid2>
					</Grid2>
				</MesfModal.Actions>
			</MesfModal>
		</>
	);
};
